import { api } from 'services/api';

import {
  BudgetInputPriceListResponse,
  BudgetInputPriceQueryParams,
  MassUpdateInputPricePayloadItem,
} from './types';

export const fetchBudgetInputPrices = async (
  budgetId: number,
  params: BudgetInputPriceQueryParams,
): Promise<BudgetInputPriceListResponse> => {
  const response = await api.get(`/budget/${budgetId}/input/price`, {
    params,
  });

  return response.data;
};

export const massUpdateBudgetInputPrices = async (
  budgetId: number,
  payload: MassUpdateInputPricePayloadItem[],
): Promise<void> => {
  await api.post(`/budget/${budgetId}/input/mass-update`, payload);
};
